module.exports = __webpack_public_path__ + "static/img/introduction-barometer-health-equity.52c102a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-barometer-health-equity.jpg
// module id = kmGp
// module chunks = 0